function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg206028186325245(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M475.79,277.045c-13.494,40.9-42.565,85.725-85.346,100.317 c-64.641,22.054-70.416,75.069-187.736,74.707c-18.292-0.055-35.271-1.97-50.936-5.47c-8.421-1.88-16.465-4.23-24.12-7.001 c-69.499-25.07-107.551-84.691-112.981-148.401C7.516,207.403,64.54,165.128,101.7,140.229 c37.16-24.899,79.531-117.452,194.867-118.002c17.585-0.076,35.199,1.647,52.355,5.593c39.163,8.991,79.458,30.67,103.664,63.702 c1.817,2.482,3.557,5.026,5.23,7.622C490.464,149.943,494.191,221.286,475.79,277.045z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M475.79,277.045c-13.494,40.9-42.565,85.725-85.346,100.317 c-64.641,22.054-70.416,75.069-187.736,74.707c-18.292-0.055-35.271-1.97-50.936-5.47c-8.421-1.88-16.465-4.23-24.12-7.001 c-69.499-25.07-107.551-84.691-112.981-148.401C7.516,207.403,64.54,165.128,101.7,140.229 c37.16-24.899,79.531-117.452,194.867-118.002c17.585-0.076,35.199,1.647,52.355,5.593c39.163,8.991,79.458,30.67,103.664,63.702 c1.817,2.482,3.557,5.026,5.23,7.622C490.464,149.943,494.191,221.286,475.79,277.045z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 481.287,
    y1: 460.703,
    x2: 15.904,
    y2: 460.703
  })), /*#__PURE__*/React.createElement("g", {
    id: "Dotted_Line"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: 5
    },
    d: " M35.874,423.218c0,0,14.695-256.974,455.921-280.335"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: 5
    },
    d: " M439.798,125.55c16.795,13.697,25.612,35.062,30.036,55.778c9.178,42.985,4.88,89.269-16.439,128.131 c-22.507,41.03-62.255,70.583-104.955,88.143c-90.521,37.225-205.749,12.818-257.151-75.509c-0.557-0.961-1.108-1.926-1.651-2.894 c-4.982-8.909-9.584-18.528-11.562-28.613"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Screen"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M294.39,314.775H37.135c-4.135,0-7.487-3.352-7.487-7.487V52.3c0-4.135,3.352-7.487,7.487-7.487 H294.39c4.135,0,7.487,3.352,7.487,7.487v254.988C301.876,311.423,298.525,314.775,294.39,314.775z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M300.948,308.49H43.694c-4.135,0-7.487-3.352-7.487-7.487 V46.015c0-4.135,3.352-7.487,7.487-7.487h257.255c4.135,0,7.487,3.352,7.487,7.487v254.988 C308.435,305.138,305.083,308.49,300.948,308.49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M240.306,227.948H104.51c-6.791,0-12.296-5.505-12.296-12.296 v-4.641c0-6.791,5.505-12.296,12.296-12.296h135.796c6.791,0,12.296,5.505,12.296,12.296v4.641 C252.602,222.443,247.097,227.948,240.306,227.948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M240.306,169.199H104.51c-6.791,0-12.296-5.505-12.296-12.296 v-4.641c0-6.791,5.505-12.296,12.296-12.296h135.796c6.791,0,12.296,5.505,12.296,12.296v4.641 C252.602,163.694,247.097,169.199,240.306,169.199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M214.601,275.161h-84.387c-6.791,0-12.296-5.505-12.296-12.296v-4.641 c0-6.791,5.505-12.296,12.296-12.296h84.387c6.791,0,12.296,5.505,12.296,12.296v4.641 C226.898,269.656,221.392,275.161,214.601,275.161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M308.435,60.061V47.076c0-4.721-3.827-8.548-8.548-8.548 H44.755c-4.721,0-8.548,3.827-8.548,8.548v12.984H308.435z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    cx: 268.998,
    cy: 50.64,
    r: 3.949
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    cx: 282.326,
    cy: 50.64,
    r: 3.949
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M299.603,50.64c0-2.181-1.768-3.949-3.949-3.949 c-2.181,0-3.949,1.768-3.949,3.949c0,2.181,1.768,3.949,3.949,3.949C297.835,54.589,299.603,52.821,299.603,50.64z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M395.981,65.924c0,10.541-4.932,19.942-12.642,25.978 c-5.609,4.434-12.713,7.069-20.405,7.069c-7.71,0-14.814-2.635-20.423-7.069c-7.71-6.036-12.642-15.437-12.642-25.978 c0-18.268,14.796-33.065,33.065-33.065C381.185,32.859,395.981,47.655,395.981,65.924z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M376.731,60.743c0-7.623-6.18-13.803-13.803-13.803 s-13.803,6.18-13.803,13.803c0,7.623,6.18,13.803,13.803,13.803S376.731,68.366,376.731,60.743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M383.339,91.902c-5.609,4.434-12.713,7.069-20.405,7.069 c-7.71,0-14.814-2.635-20.423-7.069c2.048-9.383,10.416-16.417,20.423-16.417C372.923,75.485,381.292,82.518,383.339,91.902z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Paper_Plane"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "405.06,91.275 444.787,99.504 434.104,111.734  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "405.06,91.275 418.389,128.654 430.136,115.569  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "434.104,111.734 433.199,121.142 430.136,115.569  405.06,91.275  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "433.199,121.142 428.032,118.208 430.136,115.569  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Padlock"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M342.636,343.484v-96.157c0-23.316,18.969-42.286,42.287-42.286 c23.316,0,42.286,18.969,42.286,42.286v96.157h17.454v-96.157c0-32.941-26.799-59.74-59.74-59.74h-0.001 c-32.94,0-59.74,26.799-59.74,59.74v96.157H342.636z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 316.486,
    y: 301.648,
    style: {
      fill: "#B2B2B2"
    },
    width: 142.392,
    height: 159.055
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "458.878,315.178 316.486,457.57 316.486,460.703 330.723,460.703 458.878,332.548  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "316.486,341.259 316.486,393.24 408.077,301.648 356.096,301.648  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 316.486,
    y: 301.648,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 142.392,
    height: 159.055
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.908,
    y: 301.648,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 29.97,
    height: 159.055
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M376.572,364.584c0-5.512-4.468-9.98-9.98-9.98 c-5.512,0-9.98,4.468-9.98,9.98c0,4.127,2.505,7.668,6.078,9.188l-1.832,21.671h11.469l-1.832-21.671 C374.067,372.252,376.572,368.711,376.572,364.584z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Text"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M107.832,216.298l-1.314-0.793l1.648-2.316l-2.461-0.938l0.542-1.418l2.357,1.252l-0.25-2.879 h1.69l-0.271,2.879l2.378-1.252l0.522,1.418l-2.461,0.959l1.669,2.295l-1.356,0.793l-1.335-2.607L107.832,216.298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M116.134,216.298l-1.314-0.793l1.648-2.316l-2.461-0.938l0.542-1.418l2.357,1.252l-0.25-2.879 h1.69l-0.271,2.879l2.378-1.252l0.522,1.418l-2.461,0.959l1.669,2.295l-1.356,0.793l-1.335-2.607L116.134,216.298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M124.435,216.298l-1.314-0.793l1.648-2.316l-2.461-0.938l0.542-1.418l2.357,1.252l-0.25-2.879 h1.69l-0.271,2.879l2.378-1.252l0.521,1.418l-2.461,0.959l1.669,2.295l-1.356,0.793l-1.335-2.607L124.435,216.298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M132.736,216.298l-1.314-0.793l1.648-2.316l-2.461-0.938l0.542-1.418l2.357,1.252l-0.25-2.879 h1.69l-0.271,2.879l2.378-1.252l0.521,1.418l-2.461,0.959l1.669,2.295l-1.356,0.793l-1.335-2.607L132.736,216.298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M141.038,216.298l-1.314-0.793l1.648-2.316l-2.461-0.938l0.542-1.418l2.357,1.252l-0.25-2.879 h1.69l-0.271,2.879l2.378-1.252l0.521,1.418l-2.461,0.959l1.669,2.295l-1.356,0.793l-1.335-2.607L141.038,216.298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M149.34,216.298l-1.314-0.793l1.648-2.316l-2.461-0.938l0.542-1.418l2.357,1.252l-0.25-2.879h1.69 l-0.271,2.879l2.378-1.252l0.521,1.418l-2.461,0.959l1.669,2.295l-1.356,0.793l-1.335-2.607L149.34,216.298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M157.641,216.298l-1.314-0.793l1.648-2.316l-2.461-0.938l0.542-1.418l2.357,1.252l-0.25-2.879 h1.69l-0.271,2.879l2.378-1.252l0.521,1.418l-2.461,0.959l1.669,2.295l-1.356,0.793l-1.335-2.607L157.641,216.298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M165.943,216.298l-1.314-0.793l1.648-2.316l-2.461-0.938l0.542-1.418l2.357,1.252l-0.25-2.879 h1.69l-0.271,2.879l2.378-1.252l0.521,1.418l-2.461,0.959l1.669,2.295l-1.356,0.793l-1.335-2.607L165.943,216.298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M174.244,216.298l-1.314-0.793l1.648-2.316l-2.461-0.938l0.542-1.418l2.357,1.252l-0.25-2.879 h1.69l-0.271,2.879l2.378-1.252l0.522,1.418l-2.461,0.959l1.669,2.295l-1.356,0.793l-1.335-2.607L174.244,216.298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M182.546,216.298l-1.314-0.793l1.648-2.316l-2.461-0.938l0.542-1.418l2.357,1.252l-0.25-2.879 h1.69l-0.271,2.879l2.378-1.252l0.521,1.418l-2.461,0.959l1.669,2.295l-1.355,0.793l-1.335-2.607L182.546,216.298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M190.848,216.298l-1.314-0.793l1.648-2.316l-2.461-0.938l0.542-1.418l2.357,1.252l-0.25-2.879 h1.69l-0.271,2.879l2.378-1.252l0.521,1.418l-2.461,0.959l1.669,2.295l-1.356,0.793l-1.335-2.607L190.848,216.298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M199.149,216.298l-1.314-0.793l1.648-2.316l-2.461-0.938l0.543-1.418l2.357,1.252l-0.25-2.879 h1.69l-0.271,2.879l2.378-1.252l0.522,1.418l-2.461,0.959l1.669,2.295l-1.355,0.793l-1.335-2.607L199.149,216.298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M207.451,216.298l-1.314-0.793l1.648-2.316l-2.461-0.938l0.542-1.418l2.357,1.252l-0.25-2.879 h1.69l-0.271,2.879l2.378-1.252l0.521,1.418l-2.461,0.959l1.669,2.295l-1.355,0.793l-1.335-2.607L207.451,216.298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M215.752,216.298l-1.314-0.793l1.648-2.316l-2.461-0.938l0.542-1.418l2.357,1.252l-0.25-2.879 h1.69l-0.271,2.879l2.378-1.252l0.521,1.418l-2.461,0.959l1.669,2.295l-1.356,0.793l-1.335-2.607L215.752,216.298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M224.054,216.298l-1.314-0.793l1.648-2.316l-2.461-0.938l0.542-1.418l2.357,1.252l-0.25-2.879 h1.69l-0.271,2.879l2.378-1.252l0.521,1.418l-2.461,0.959l1.669,2.295l-1.356,0.793l-1.335-2.607L224.054,216.298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M232.355,216.298l-1.314-0.793l1.648-2.316l-2.461-0.938l0.542-1.418l2.357,1.252l-0.25-2.879 h1.69l-0.271,2.879l2.378-1.252l0.521,1.418l-2.461,0.959l1.669,2.295l-1.356,0.793l-1.335-2.607L232.355,216.298z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M107.832,157.549l-1.314-0.793l1.648-2.315l-2.461-0.939l0.542-1.418l2.357,1.252l-0.25-2.879 h1.69l-0.271,2.879l2.378-1.252l0.522,1.418l-2.461,0.96l1.669,2.295l-1.356,0.793l-1.335-2.607L107.832,157.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M116.134,157.549l-1.314-0.793l1.648-2.315l-2.461-0.939l0.542-1.418l2.357,1.252l-0.25-2.879 h1.69l-0.271,2.879l2.378-1.252l0.522,1.418l-2.461,0.96l1.669,2.295l-1.356,0.793l-1.335-2.607L116.134,157.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M124.435,157.549l-1.314-0.793l1.648-2.315l-2.461-0.939l0.542-1.418l2.357,1.252l-0.25-2.879 h1.69l-0.271,2.879l2.378-1.252l0.521,1.418l-2.461,0.96l1.669,2.295l-1.356,0.793l-1.335-2.607L124.435,157.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M132.736,157.549l-1.314-0.793l1.648-2.315l-2.461-0.939l0.542-1.418l2.357,1.252l-0.25-2.879 h1.69l-0.271,2.879l2.378-1.252l0.521,1.418l-2.461,0.96l1.669,2.295l-1.356,0.793l-1.335-2.607L132.736,157.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M141.038,157.549l-1.314-0.793l1.648-2.315l-2.461-0.939l0.542-1.418l2.357,1.252l-0.25-2.879 h1.69l-0.271,2.879l2.378-1.252l0.521,1.418l-2.461,0.96l1.669,2.295l-1.356,0.793l-1.335-2.607L141.038,157.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M149.34,157.549l-1.314-0.793l1.648-2.315l-2.461-0.939l0.542-1.418l2.357,1.252l-0.25-2.879h1.69 l-0.271,2.879l2.378-1.252l0.521,1.418l-2.461,0.96l1.669,2.295l-1.356,0.793l-1.335-2.607L149.34,157.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M157.641,157.549l-1.314-0.793l1.648-2.315l-2.461-0.939l0.542-1.418l2.357,1.252l-0.25-2.879 h1.69l-0.271,2.879l2.378-1.252l0.521,1.418l-2.461,0.96l1.669,2.295l-1.356,0.793l-1.335-2.607L157.641,157.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M165.943,157.549l-1.314-0.793l1.648-2.315l-2.461-0.939l0.542-1.418l2.357,1.252l-0.25-2.879 h1.69l-0.271,2.879l2.378-1.252l0.521,1.418l-2.461,0.96l1.669,2.295l-1.356,0.793l-1.335-2.607L165.943,157.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M174.244,157.549l-1.314-0.793l1.648-2.315l-2.461-0.939l0.542-1.418l2.357,1.252l-0.25-2.879 h1.69l-0.271,2.879l2.378-1.252l0.522,1.418l-2.461,0.96l1.669,2.295l-1.356,0.793l-1.335-2.607L174.244,157.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M182.546,157.549l-1.314-0.793l1.648-2.315l-2.461-0.939l0.542-1.418l2.357,1.252l-0.25-2.879 h1.69l-0.271,2.879l2.378-1.252l0.521,1.418l-2.461,0.96l1.669,2.295l-1.355,0.793l-1.335-2.607L182.546,157.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M190.848,157.549l-1.314-0.793l1.648-2.315l-2.461-0.939l0.542-1.418l2.357,1.252l-0.25-2.879 h1.69l-0.271,2.879l2.378-1.252l0.521,1.418l-2.461,0.96l1.669,2.295l-1.356,0.793l-1.335-2.607L190.848,157.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M199.149,157.549l-1.314-0.793l1.648-2.315l-2.461-0.939l0.543-1.418l2.357,1.252l-0.25-2.879 h1.69l-0.271,2.879l2.378-1.252l0.522,1.418l-2.461,0.96l1.669,2.295l-1.355,0.793l-1.335-2.607L199.149,157.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M207.451,157.549l-1.314-0.793l1.648-2.315l-2.461-0.939l0.542-1.418l2.357,1.252l-0.25-2.879 h1.69l-0.271,2.879l2.378-1.252l0.521,1.418l-2.461,0.96l1.669,2.295l-1.355,0.793l-1.335-2.607L207.451,157.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M215.752,157.549l-1.314-0.793l1.648-2.315l-2.461-0.939l0.542-1.418l2.357,1.252l-0.25-2.879 h1.69l-0.271,2.879l2.378-1.252l0.521,1.418l-2.461,0.96l1.669,2.295l-1.356,0.793l-1.335-2.607L215.752,157.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M224.054,157.549l-1.314-0.793l1.648-2.315l-2.461-0.939l0.542-1.418l2.357,1.252l-0.25-2.879 h1.69l-0.271,2.879l2.378-1.252l0.521,1.418l-2.461,0.96l1.669,2.295l-1.356,0.793l-1.335-2.607L224.054,157.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M232.355,157.549l-1.314-0.793l1.648-2.315l-2.461-0.939l0.542-1.418l2.357,1.252l-0.25-2.879 h1.69l-0.271,2.879l2.378-1.252l0.521,1.418l-2.461,0.96l1.669,2.295l-1.356,0.793l-1.335-2.607L232.355,157.549z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M149.36,132.03v-8.666h2.15c0.521,0,0.936,0.095,1.247,0.284c0.31,0.189,0.536,0.462,0.679,0.818 c0.143,0.356,0.214,0.788,0.214,1.294c0,0.456-0.08,0.852-0.241,1.188c-0.16,0.335-0.398,0.594-0.711,0.775 c-0.314,0.182-0.706,0.273-1.177,0.273h-0.952v4.033H149.36z M150.568,127.13h0.556c0.35,0,0.624-0.039,0.824-0.118 c0.2-0.079,0.342-0.216,0.428-0.412c0.085-0.196,0.128-0.472,0.128-0.829c0-0.414-0.031-0.731-0.091-0.952 c-0.061-0.221-0.187-0.375-0.38-0.46c-0.193-0.086-0.492-0.129-0.899-0.129h-0.568V127.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M153.618,132.03l1.84-8.666h1.166l1.851,8.666h-1.145l-0.396-2.183h-1.766l-0.417,2.183H153.618z  M155.329,128.981h1.444l-0.727-3.905L155.329,128.981z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M161.395,132.126c-0.499,0-0.914-0.107-1.246-0.321c-0.332-0.214-0.583-0.51-0.754-0.888 c-0.171-0.378-0.271-0.817-0.3-1.316l1.07-0.289c0.022,0.307,0.07,0.603,0.144,0.887c0.075,0.285,0.199,0.519,0.37,0.701 c0.171,0.182,0.41,0.273,0.716,0.273c0.314,0,0.551-0.088,0.711-0.262c0.161-0.175,0.241-0.426,0.241-0.754 c0-0.392-0.089-0.708-0.268-0.947c-0.178-0.239-0.403-0.479-0.674-0.722l-1.454-1.284c-0.285-0.249-0.496-0.522-0.632-0.818 c-0.135-0.296-0.203-0.661-0.203-1.097c0-0.634,0.182-1.127,0.545-1.476c0.364-0.35,0.86-0.524,1.487-0.524 c0.342,0,0.643,0.045,0.904,0.134c0.26,0.089,0.478,0.226,0.653,0.411c0.174,0.186,0.314,0.419,0.418,0.701 c0.103,0.282,0.173,0.612,0.208,0.99l-1.027,0.278c-0.021-0.285-0.064-0.547-0.128-0.786c-0.064-0.239-0.176-0.431-0.337-0.578 c-0.161-0.146-0.391-0.22-0.69-0.22c-0.299,0-0.533,0.08-0.701,0.241c-0.168,0.161-0.251,0.397-0.251,0.711 c0,0.264,0.045,0.482,0.134,0.653c0.089,0.171,0.234,0.346,0.433,0.524l1.466,1.284c0.328,0.285,0.617,0.626,0.867,1.022 c0.249,0.396,0.374,0.865,0.374,1.407c0,0.428-0.089,0.797-0.268,1.107c-0.178,0.311-0.423,0.547-0.732,0.711 C162.16,132.044,161.802,132.126,161.395,132.126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M166.455,132.126c-0.499,0-0.914-0.107-1.246-0.321c-0.332-0.214-0.583-0.51-0.754-0.888 c-0.171-0.378-0.271-0.817-0.3-1.316l1.07-0.289c0.022,0.307,0.07,0.603,0.144,0.887c0.075,0.285,0.199,0.519,0.37,0.701 c0.171,0.182,0.41,0.273,0.716,0.273c0.314,0,0.551-0.088,0.711-0.262c0.161-0.175,0.241-0.426,0.241-0.754 c0-0.392-0.089-0.708-0.268-0.947c-0.178-0.239-0.402-0.479-0.674-0.722l-1.454-1.284c-0.285-0.249-0.496-0.522-0.632-0.818 s-0.203-0.661-0.203-1.097c0-0.634,0.182-1.127,0.545-1.476c0.364-0.35,0.86-0.524,1.487-0.524c0.342,0,0.643,0.045,0.904,0.134 c0.26,0.089,0.478,0.226,0.653,0.411c0.174,0.186,0.314,0.419,0.418,0.701c0.103,0.282,0.173,0.612,0.208,0.99l-1.027,0.278 c-0.021-0.285-0.064-0.547-0.128-0.786c-0.064-0.239-0.176-0.431-0.337-0.578c-0.161-0.146-0.391-0.22-0.69-0.22 c-0.299,0-0.534,0.08-0.701,0.241c-0.168,0.161-0.251,0.397-0.251,0.711c0,0.264,0.045,0.482,0.134,0.653 c0.089,0.171,0.234,0.346,0.433,0.524l1.466,1.284c0.328,0.285,0.617,0.626,0.867,1.022c0.249,0.396,0.374,0.865,0.374,1.407 c0,0.428-0.089,0.797-0.268,1.107c-0.178,0.311-0.423,0.547-0.733,0.711C167.22,132.044,166.862,132.126,166.455,132.126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M170.596,132.03l-1.412-8.666h1.006l0.93,6.227l1.166-6.194h0.856l1.177,6.226l0.909-6.258h0.985 l-1.391,8.666h-0.878l-1.209-6.419l-1.22,6.419H170.596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M179.4,132.126c-0.585,0-1.052-0.114-1.402-0.342c-0.35-0.229-0.599-0.555-0.749-0.979 c-0.15-0.424-0.225-0.922-0.225-1.492v-3.285c0-0.57,0.076-1.06,0.23-1.471c0.153-0.41,0.402-0.724,0.749-0.942 c0.346-0.217,0.811-0.326,1.396-0.326c0.585,0,1.049,0.11,1.391,0.332c0.342,0.221,0.59,0.535,0.744,0.941 c0.153,0.407,0.23,0.895,0.23,1.466v3.295c0,0.564-0.076,1.055-0.23,1.476s-0.401,0.747-0.744,0.979 C180.449,132.01,179.985,132.126,179.4,132.126z M179.4,131.174c0.321,0,0.564-0.066,0.727-0.198 c0.164-0.132,0.275-0.317,0.332-0.556c0.057-0.239,0.086-0.519,0.086-0.84v-3.798c0-0.321-0.029-0.597-0.086-0.829 c-0.057-0.232-0.168-0.41-0.332-0.535c-0.164-0.124-0.406-0.187-0.727-0.187c-0.321,0-0.565,0.063-0.733,0.187 c-0.168,0.125-0.28,0.303-0.337,0.535c-0.057,0.232-0.085,0.508-0.085,0.829v3.798c0,0.321,0.028,0.601,0.085,0.84 c0.057,0.239,0.169,0.424,0.337,0.556C178.835,131.108,179.079,131.174,179.4,131.174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M182.952,132.03v-8.666h1.744c0.578,0,1.055,0.077,1.433,0.23s0.658,0.399,0.84,0.738 c0.182,0.338,0.273,0.783,0.273,1.332c0,0.335-0.036,0.64-0.107,0.915c-0.071,0.274-0.186,0.506-0.342,0.695 c-0.157,0.189-0.364,0.326-0.621,0.412l1.23,4.343h-1.166l-1.134-4.065h-0.942v4.065H182.952z M184.16,127.098h0.461 c0.342,0,0.62-0.042,0.834-0.128c0.214-0.085,0.371-0.232,0.471-0.439c0.1-0.207,0.149-0.496,0.149-0.866 c0-0.506-0.093-0.872-0.278-1.097c-0.186-0.225-0.553-0.337-1.102-0.337h-0.535V127.098z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M188.505,132.03v-8.666h1.883c0.642,0,1.15,0.098,1.525,0.294c0.375,0.196,0.642,0.49,0.802,0.882 s0.241,0.881,0.241,1.466v3.188c0,0.613-0.08,1.13-0.241,1.551s-0.421,0.74-0.781,0.958c-0.36,0.217-0.843,0.326-1.449,0.326 H188.505z M189.713,131.163h0.685c0.442,0,0.756-0.086,0.941-0.257c0.186-0.171,0.298-0.421,0.337-0.749 c0.039-0.328,0.059-0.724,0.059-1.187v-2.814c0-0.449-0.028-0.813-0.085-1.091c-0.057-0.278-0.182-0.481-0.375-0.61 c-0.192-0.128-0.496-0.192-0.909-0.192h-0.653V131.163z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M90.233,100.494V86.622h3.596c0.936,0,1.738,0.105,2.406,0.317 c0.668,0.211,1.182,0.585,1.541,1.122c0.36,0.537,0.54,1.279,0.54,2.227c0,0.571-0.049,1.076-0.146,1.516 c-0.098,0.439-0.269,0.822-0.514,1.147c-0.246,0.326-0.591,0.585-1.036,0.779l1.918,6.765h-2.895l-1.593-6.285h-0.993v6.285 H90.233z M93.059,92.53h0.822c0.457,0,0.816-0.074,1.079-0.222c0.263-0.148,0.448-0.374,0.556-0.677 c0.108-0.302,0.163-0.676,0.163-1.122c0-0.639-0.117-1.127-0.351-1.464c-0.234-0.337-0.671-0.506-1.31-0.506h-0.959V92.53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M100.167,100.494V86.622h6.045v1.952h-3.219v3.682h2.483v1.969h-2.483v4.35h3.254v1.918H100.167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M111.264,100.683c-0.856,0-1.57-0.157-2.141-0.471c-0.571-0.314-1.002-0.788-1.293-1.422 c-0.291-0.633-0.46-1.441-0.505-2.423l2.432-0.411c0.023,0.572,0.082,1.048,0.179,1.43c0.097,0.383,0.245,0.668,0.446,0.856 c0.2,0.188,0.448,0.283,0.745,0.283c0.366,0,0.614-0.114,0.745-0.342c0.131-0.229,0.197-0.491,0.197-0.788 c0-0.583-0.14-1.07-0.42-1.465c-0.28-0.394-0.648-0.791-1.104-1.19l-1.439-1.25c-0.514-0.434-0.933-0.925-1.259-1.473 c-0.325-0.548-0.488-1.222-0.488-2.021c0-1.142,0.334-2.018,1.002-2.629c0.668-0.61,1.584-0.916,2.749-0.916 c0.696,0,1.267,0.114,1.713,0.342c0.445,0.229,0.79,0.534,1.036,0.917c0.245,0.382,0.417,0.799,0.514,1.25 c0.097,0.451,0.157,0.899,0.18,1.345l-2.414,0.36c-0.023-0.423-0.06-0.793-0.112-1.113c-0.051-0.319-0.154-0.571-0.308-0.754 c-0.154-0.182-0.385-0.274-0.693-0.274c-0.331,0-0.576,0.123-0.736,0.368c-0.16,0.246-0.24,0.517-0.24,0.813 c0,0.491,0.111,0.894,0.334,1.208c0.222,0.314,0.528,0.642,0.916,0.985l1.404,1.233c0.582,0.503,1.081,1.076,1.498,1.721 c0.416,0.645,0.625,1.442,0.625,2.389c0,0.651-0.149,1.239-0.445,1.764c-0.297,0.526-0.711,0.937-1.242,1.233 C112.609,100.534,111.983,100.683,111.264,100.683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M116.094,100.494V86.622h6.045v1.952h-3.219v3.682h2.483v1.969h-2.483v4.35h3.254v1.918H116.094z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M124.896,100.494V88.728h-2.141v-2.106h7.09v2.106h-2.107v11.766H124.896z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M137.192,100.494v-5.498l-2.706-8.375h2.655l1.49,4.881l1.387-4.881h2.569l-2.672,8.375v5.498 H137.192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M147.417,100.683c-1.016,0-1.821-0.183-2.415-0.548c-0.594-0.365-1.019-0.887-1.276-1.567 c-0.256-0.679-0.385-1.492-0.385-2.441v-5.172c0-0.948,0.129-1.758,0.385-2.432c0.257-0.674,0.682-1.188,1.276-1.542 c0.594-0.354,1.399-0.531,2.415-0.531c1.027,0,1.841,0.18,2.44,0.539c0.599,0.36,1.027,0.874,1.285,1.542 s0.385,1.476,0.385,2.423v5.172c0,0.948-0.128,1.762-0.385,2.441c-0.257,0.68-0.685,1.202-1.285,1.567 C149.258,100.5,148.445,100.683,147.417,100.683z M147.417,98.644c0.365,0,0.633-0.083,0.804-0.248 c0.172-0.166,0.285-0.388,0.343-0.668c0.057-0.28,0.085-0.579,0.085-0.899V90.27c0-0.319-0.028-0.617-0.085-0.89 c-0.057-0.274-0.171-0.494-0.343-0.66c-0.171-0.166-0.439-0.248-0.804-0.248c-0.343,0-0.6,0.082-0.771,0.248 c-0.171,0.166-0.285,0.385-0.342,0.66c-0.057,0.274-0.086,0.571-0.086,0.89v6.559c0,0.32,0.026,0.619,0.077,0.899 c0.052,0.28,0.163,0.502,0.334,0.668C146.801,98.562,147.063,98.644,147.417,98.644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M157.316,100.683c-1.05,0-1.867-0.18-2.449-0.54c-0.582-0.359-0.991-0.879-1.224-1.558 c-0.234-0.68-0.351-1.504-0.351-2.475v-9.488h2.791v9.882c0,0.343,0.026,0.68,0.077,1.011c0.052,0.331,0.166,0.599,0.343,0.805 c0.177,0.205,0.448,0.308,0.813,0.308c0.377,0,0.653-0.103,0.831-0.308c0.177-0.206,0.288-0.474,0.334-0.805 c0.046-0.331,0.069-0.668,0.069-1.011v-9.882h2.791v9.488c0,0.97-0.117,1.795-0.351,2.475c-0.234,0.679-0.642,1.199-1.225,1.558 C159.183,100.502,158.366,100.683,157.316,100.683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M163.31,100.494V86.622h3.596c0.936,0,1.738,0.105,2.406,0.317 c0.668,0.211,1.182,0.585,1.541,1.122c0.36,0.537,0.54,1.279,0.54,2.227c0,0.571-0.049,1.076-0.146,1.516 c-0.098,0.439-0.269,0.822-0.514,1.147c-0.246,0.326-0.591,0.585-1.036,0.779l1.918,6.765h-2.895l-1.593-6.285h-0.993v6.285 H163.31z M166.136,92.53h0.822c0.457,0,0.816-0.074,1.079-0.222c0.263-0.148,0.448-0.374,0.556-0.677 c0.108-0.302,0.163-0.676,0.163-1.122c0-0.639-0.117-1.127-0.351-1.464c-0.234-0.337-0.671-0.506-1.31-0.506h-0.959V92.53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M177.524,100.494V86.622h4.401c0.834,0,1.513,0.157,2.038,0.471 c0.525,0.314,0.916,0.768,1.173,1.361c0.257,0.594,0.385,1.313,0.385,2.158c0,0.993-0.168,1.77-0.505,2.329 c-0.337,0.56-0.797,0.957-1.379,1.191c-0.582,0.234-1.25,0.351-2.004,0.351h-1.284v6.012H177.524z M180.35,92.496h0.993 c0.411,0,0.728-0.066,0.951-0.197c0.223-0.131,0.374-0.34,0.454-0.625c0.08-0.285,0.12-0.651,0.12-1.096 c0-0.422-0.032-0.776-0.094-1.062c-0.063-0.285-0.203-0.508-0.42-0.668c-0.217-0.16-0.56-0.24-1.027-0.24h-0.976V92.496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M185.522,100.494l2.689-13.872h3.134l2.672,13.872h-2.62l-0.497-3.048h-2.192l-0.531,3.048 H185.522z M188.964,95.716h1.661l-0.84-5.6L188.964,95.716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M198.914,100.683c-0.856,0-1.57-0.157-2.141-0.471c-0.571-0.314-1.002-0.788-1.293-1.422 c-0.291-0.633-0.46-1.441-0.505-2.423l2.432-0.411c0.023,0.572,0.083,1.048,0.18,1.43c0.097,0.383,0.245,0.668,0.445,0.856 c0.2,0.188,0.448,0.283,0.745,0.283c0.366,0,0.614-0.114,0.745-0.342c0.131-0.229,0.197-0.491,0.197-0.788 c0-0.583-0.14-1.07-0.42-1.465c-0.28-0.394-0.648-0.791-1.104-1.19l-1.439-1.25c-0.514-0.434-0.933-0.925-1.259-1.473 c-0.325-0.548-0.488-1.222-0.488-2.021c0-1.142,0.334-2.018,1.002-2.629c0.668-0.61,1.584-0.916,2.749-0.916 c0.696,0,1.267,0.114,1.713,0.342c0.445,0.229,0.79,0.534,1.036,0.917c0.245,0.382,0.417,0.799,0.514,1.25 c0.097,0.451,0.157,0.899,0.179,1.345l-2.414,0.36c-0.023-0.423-0.06-0.793-0.112-1.113c-0.051-0.319-0.154-0.571-0.308-0.754 c-0.154-0.182-0.385-0.274-0.694-0.274c-0.331,0-0.576,0.123-0.736,0.368c-0.16,0.246-0.24,0.517-0.24,0.813 c0,0.491,0.111,0.894,0.334,1.208c0.222,0.314,0.528,0.642,0.917,0.985l1.404,1.233c0.582,0.503,1.081,1.076,1.499,1.721 c0.417,0.645,0.625,1.442,0.625,2.389c0,0.651-0.149,1.239-0.445,1.764c-0.297,0.526-0.711,0.937-1.242,1.233 C200.259,100.534,199.634,100.683,198.914,100.683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M207.34,100.683c-0.856,0-1.57-0.157-2.141-0.471c-0.571-0.314-1.002-0.788-1.293-1.422 c-0.291-0.633-0.46-1.441-0.505-2.423l2.432-0.411c0.023,0.572,0.082,1.048,0.179,1.43c0.097,0.383,0.245,0.668,0.445,0.856 c0.2,0.188,0.448,0.283,0.745,0.283c0.366,0,0.614-0.114,0.745-0.342c0.131-0.229,0.197-0.491,0.197-0.788 c0-0.583-0.14-1.07-0.42-1.465c-0.28-0.394-0.648-0.791-1.104-1.19l-1.439-1.25c-0.513-0.434-0.933-0.925-1.259-1.473 c-0.325-0.548-0.488-1.222-0.488-2.021c0-1.142,0.334-2.018,1.002-2.629c0.668-0.61,1.584-0.916,2.749-0.916 c0.696,0,1.267,0.114,1.713,0.342c0.445,0.229,0.79,0.534,1.036,0.917c0.245,0.382,0.417,0.799,0.514,1.25 c0.097,0.451,0.157,0.899,0.18,1.345l-2.415,0.36c-0.023-0.423-0.06-0.793-0.111-1.113c-0.051-0.319-0.154-0.571-0.308-0.754 c-0.154-0.182-0.385-0.274-0.693-0.274c-0.331,0-0.576,0.123-0.736,0.368c-0.16,0.246-0.24,0.517-0.24,0.813 c0,0.491,0.111,0.894,0.334,1.208c0.222,0.314,0.528,0.642,0.917,0.985l1.404,1.233c0.582,0.503,1.082,1.076,1.499,1.721 c0.416,0.645,0.625,1.442,0.625,2.389c0,0.651-0.149,1.239-0.445,1.764c-0.297,0.526-0.711,0.937-1.242,1.233 C208.685,100.534,208.06,100.683,207.34,100.683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M213.643,100.494l-1.798-13.872h2.398l0.959,8.477l1.216-8.46h1.901l1.267,8.443l0.959-8.46h2.363 l-1.781,13.872h-2.398l-1.353-8.785l-1.284,8.785H213.643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M228.269,100.683c-1.016,0-1.821-0.183-2.415-0.548c-0.594-0.365-1.019-0.887-1.276-1.567 c-0.257-0.679-0.385-1.492-0.385-2.441v-5.172c0-0.948,0.129-1.758,0.385-2.432c0.257-0.674,0.682-1.188,1.276-1.542 c0.594-0.354,1.399-0.531,2.415-0.531c1.027,0,1.841,0.18,2.44,0.539c0.599,0.36,1.027,0.874,1.284,1.542 c0.257,0.668,0.385,1.476,0.385,2.423v5.172c0,0.948-0.128,1.762-0.385,2.441c-0.257,0.68-0.685,1.202-1.284,1.567 C230.11,100.5,229.297,100.683,228.269,100.683z M228.269,98.644c0.365,0,0.633-0.083,0.805-0.248 c0.172-0.166,0.285-0.388,0.343-0.668c0.057-0.28,0.085-0.579,0.085-0.899V90.27c0-0.319-0.028-0.617-0.085-0.89 c-0.057-0.274-0.171-0.494-0.343-0.66c-0.171-0.166-0.439-0.248-0.805-0.248c-0.343,0-0.6,0.082-0.771,0.248 c-0.171,0.166-0.285,0.385-0.342,0.66c-0.057,0.274-0.086,0.571-0.086,0.89v6.559c0,0.32,0.026,0.619,0.077,0.899 c0.052,0.28,0.163,0.502,0.334,0.668C227.653,98.562,227.915,98.644,228.269,98.644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M234.263,100.494V86.622h3.596c0.936,0,1.738,0.105,2.406,0.317 c0.668,0.211,1.182,0.585,1.542,1.122c0.36,0.537,0.54,1.279,0.54,2.227c0,0.571-0.049,1.076-0.146,1.516 c-0.098,0.439-0.269,0.822-0.514,1.147c-0.246,0.326-0.591,0.585-1.036,0.779l1.918,6.765h-2.895l-1.593-6.285h-0.993v6.285 H234.263z M237.089,92.53h0.822c0.457,0,0.816-0.074,1.079-0.222c0.263-0.148,0.448-0.374,0.556-0.677 c0.108-0.302,0.163-0.676,0.163-1.122c0-0.639-0.117-1.127-0.351-1.464c-0.234-0.337-0.671-0.506-1.31-0.506h-0.959V92.53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M244.196,100.494V86.622h3.391c1.176,0,2.092,0.151,2.749,0.454 c0.656,0.303,1.122,0.777,1.396,1.422c0.274,0.645,0.411,1.47,0.411,2.475v5.052c0,1.027-0.137,1.873-0.411,2.535 c-0.274,0.662-0.734,1.15-1.379,1.464c-0.646,0.314-1.544,0.471-2.698,0.471H244.196z M247.022,98.524h0.599 c0.525,0,0.899-0.082,1.122-0.248c0.223-0.166,0.362-0.411,0.42-0.736c0.057-0.326,0.085-0.728,0.085-1.208v-5.72 c0-0.48-0.037-0.865-0.111-1.156c-0.075-0.291-0.223-0.505-0.446-0.642c-0.222-0.137-0.585-0.206-1.088-0.206h-0.582V98.524z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E8E8"
    },
    d: "M127.248,266.065c-0.711,0-1.275-0.134-1.69-0.403c-0.415-0.269-0.705-0.642-0.871-1.121 c-0.166-0.478-0.249-1.034-0.249-1.666v-3.45c0-0.664,0.083-1.235,0.249-1.714c0.166-0.478,0.457-0.847,0.871-1.108 c0.415-0.261,0.978-0.391,1.69-0.391c0.687,0,1.227,0.115,1.618,0.344c0.391,0.229,0.668,0.553,0.83,0.972 c0.162,0.419,0.243,0.905,0.243,1.458v0.806h-1.897v-0.901c0-0.221-0.012-0.429-0.036-0.623 c-0.024-0.193-0.089-0.352-0.196-0.474c-0.106-0.122-0.29-0.183-0.551-0.183s-0.45,0.063-0.569,0.189 c-0.119,0.127-0.193,0.29-0.225,0.492c-0.032,0.201-0.047,0.425-0.047,0.67v4.363c0,0.269,0.022,0.504,0.065,0.705 c0.044,0.202,0.127,0.356,0.249,0.463c0.122,0.107,0.298,0.16,0.527,0.16c0.253,0,0.433-0.061,0.54-0.184 c0.107-0.122,0.173-0.286,0.201-0.492c0.028-0.206,0.042-0.423,0.042-0.652v-0.936h1.897v0.794c0,0.561-0.079,1.057-0.238,1.488 c-0.158,0.431-0.431,0.771-0.818,1.02C128.497,265.94,127.952,266.065,127.248,266.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E8E8"
    },
    d: "M131.161,265.934v-9.604h1.956v3.948h1.696v-3.948h1.956v9.604h-1.956v-4.257h-1.696v4.257 H131.161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E8E8"
    },
    d: "M137.777,265.934l1.861-9.604h2.17l1.85,9.604h-1.814l-0.344-2.111h-1.518l-0.368,2.111H137.777z  M140.161,262.626h1.15l-0.581-3.877L140.161,262.626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E8E8"
    },
    d: "M144.559,265.934v-9.604h1.364l2.135,5.004v-5.004h1.612v9.604h-1.304l-2.135-5.312v5.312H144.559 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E8E8"
    },
    d: "M153.582,266.076c-0.648,0-1.162-0.136-1.542-0.409c-0.38-0.273-0.65-0.66-0.812-1.162 c-0.162-0.502-0.243-1.085-0.243-1.749v-3.213c0-0.687,0.083-1.281,0.249-1.778c0.166-0.498,0.457-0.881,0.871-1.15 c0.415-0.269,0.978-0.403,1.69-0.403c0.687,0,1.231,0.115,1.63,0.344c0.399,0.229,0.686,0.553,0.86,0.972 c0.174,0.419,0.261,0.917,0.261,1.494v0.557h-1.909v-0.676c0-0.253-0.016-0.476-0.047-0.67c-0.032-0.194-0.105-0.346-0.22-0.457 c-0.114-0.11-0.298-0.166-0.551-0.166c-0.261,0-0.45,0.067-0.569,0.201c-0.118,0.134-0.193,0.307-0.225,0.516 c-0.032,0.21-0.047,0.433-0.047,0.67v4.257c0,0.269,0.024,0.51,0.071,0.724s0.136,0.379,0.266,0.498 c0.13,0.119,0.318,0.178,0.564,0.178c0.245,0,0.434-0.063,0.569-0.19c0.134-0.126,0.227-0.298,0.278-0.516 c0.051-0.217,0.077-0.464,0.077-0.741v-1.02h-0.937v-1.186h2.704v4.933h-1.281l-0.119-0.866 c-0.126,0.293-0.316,0.534-0.569,0.724C154.349,265.982,154.009,266.076,153.582,266.076z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E8E8"
    },
    d: "M157.909,265.934v-9.604h4.186v1.351h-2.229v2.549h1.719v1.364h-1.719v3.012h2.253v1.328H157.909z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E8E8"
    },
    d: "M166.067,265.934v-9.604h3.047c0.577,0,1.048,0.109,1.411,0.326 c0.363,0.218,0.634,0.532,0.812,0.943c0.178,0.411,0.267,0.909,0.267,1.494c0,0.688-0.117,1.225-0.35,1.613 c-0.233,0.387-0.551,0.662-0.954,0.824c-0.403,0.162-0.865,0.243-1.387,0.243h-0.889v4.162H166.067z M168.024,260.397h0.687 c0.285,0,0.504-0.046,0.658-0.137c0.154-0.091,0.259-0.235,0.314-0.433c0.055-0.197,0.083-0.45,0.083-0.759 c0-0.293-0.022-0.537-0.065-0.735c-0.044-0.197-0.141-0.352-0.29-0.462c-0.15-0.111-0.387-0.166-0.711-0.166h-0.676V260.397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E8E8"
    },
    d: "M171.605,265.934l1.861-9.604h2.17l1.85,9.604h-1.814l-0.344-2.111h-1.517l-0.368,2.111H171.605z  M173.988,262.626h1.15l-0.581-3.877L173.988,262.626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E8E8"
    },
    d: "M180.876,266.065c-0.593,0-1.087-0.109-1.482-0.326c-0.395-0.217-0.694-0.545-0.895-0.984 c-0.201-0.439-0.318-0.998-0.35-1.678l1.684-0.284c0.016,0.395,0.057,0.725,0.124,0.99c0.067,0.265,0.17,0.462,0.308,0.593 c0.138,0.131,0.311,0.196,0.516,0.196c0.253,0,0.425-0.079,0.516-0.237c0.091-0.158,0.136-0.34,0.136-0.546 c0-0.403-0.097-0.741-0.291-1.014c-0.193-0.273-0.449-0.547-0.765-0.824l-0.996-0.866c-0.356-0.3-0.646-0.64-0.871-1.02 c-0.225-0.379-0.338-0.846-0.338-1.399c0-0.79,0.231-1.397,0.694-1.82c0.462-0.423,1.097-0.634,1.903-0.634 c0.482,0,0.877,0.079,1.186,0.237c0.308,0.158,0.547,0.37,0.717,0.634c0.17,0.265,0.288,0.554,0.356,0.866 c0.067,0.312,0.109,0.622,0.124,0.93l-1.672,0.249c-0.016-0.292-0.041-0.549-0.077-0.771c-0.036-0.221-0.107-0.395-0.214-0.522 c-0.107-0.126-0.267-0.19-0.48-0.19c-0.229,0-0.399,0.085-0.51,0.255c-0.11,0.17-0.166,0.357-0.166,0.563 c0,0.34,0.077,0.619,0.231,0.836c0.154,0.217,0.366,0.445,0.634,0.682l0.972,0.854c0.403,0.348,0.749,0.745,1.038,1.191 c0.289,0.447,0.433,0.998,0.433,1.654c0,0.451-0.103,0.858-0.308,1.221c-0.206,0.363-0.492,0.648-0.86,0.853 C181.807,265.962,181.374,266.065,180.876,266.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E8E8"
    },
    d: "M186.71,266.065c-0.593,0-1.087-0.109-1.482-0.326c-0.395-0.217-0.693-0.545-0.895-0.984 c-0.201-0.439-0.318-0.998-0.35-1.678l1.684-0.284c0.016,0.395,0.057,0.725,0.124,0.99c0.067,0.265,0.17,0.462,0.308,0.593 c0.138,0.131,0.311,0.196,0.516,0.196c0.253,0,0.425-0.079,0.516-0.237c0.091-0.158,0.136-0.34,0.136-0.546 c0-0.403-0.096-0.741-0.29-1.014c-0.193-0.273-0.449-0.547-0.765-0.824l-0.996-0.866c-0.356-0.3-0.646-0.64-0.871-1.02 c-0.225-0.379-0.338-0.846-0.338-1.399c0-0.79,0.231-1.397,0.694-1.82c0.462-0.423,1.096-0.634,1.903-0.634 c0.482,0,0.878,0.079,1.186,0.237c0.308,0.158,0.547,0.37,0.717,0.634c0.17,0.265,0.288,0.554,0.356,0.866 c0.067,0.312,0.109,0.622,0.124,0.93l-1.672,0.249c-0.016-0.292-0.041-0.549-0.077-0.771c-0.036-0.221-0.106-0.395-0.213-0.522 c-0.107-0.126-0.267-0.19-0.48-0.19c-0.229,0-0.399,0.085-0.51,0.255c-0.11,0.17-0.166,0.357-0.166,0.563 c0,0.34,0.077,0.619,0.231,0.836c0.154,0.217,0.366,0.445,0.634,0.682l0.972,0.854c0.403,0.348,0.749,0.745,1.038,1.191 c0.289,0.447,0.433,0.998,0.433,1.654c0,0.451-0.103,0.858-0.308,1.221c-0.206,0.363-0.492,0.648-0.86,0.853 C187.64,265.962,187.208,266.065,186.71,266.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E8E8"
    },
    d: "M191.073,265.934l-1.245-9.604h1.66l0.664,5.869l0.842-5.857h1.316l0.878,5.845l0.664-5.857h1.636 l-1.233,9.604h-1.66l-0.937-6.083l-0.889,6.083H191.073z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E8E8"
    },
    d: "M201.199,266.065c-0.704,0-1.261-0.126-1.672-0.38c-0.411-0.253-0.705-0.614-0.883-1.085 c-0.178-0.47-0.267-1.033-0.267-1.689v-3.581c0-0.656,0.089-1.218,0.267-1.684c0.178-0.466,0.472-0.822,0.883-1.067 c0.411-0.245,0.968-0.367,1.672-0.367c0.711,0,1.274,0.124,1.69,0.374c0.415,0.249,0.711,0.605,0.889,1.067 c0.178,0.463,0.267,1.022,0.267,1.678v3.581c0,0.656-0.089,1.219-0.267,1.689c-0.178,0.47-0.474,0.832-0.889,1.085 C202.473,265.938,201.91,266.065,201.199,266.065z M201.199,264.654c0.253,0,0.439-0.057,0.557-0.172 c0.118-0.115,0.197-0.269,0.237-0.463c0.04-0.193,0.059-0.401,0.059-0.622v-4.541c0-0.221-0.02-0.427-0.059-0.617 c-0.04-0.19-0.119-0.342-0.237-0.457c-0.119-0.114-0.304-0.172-0.557-0.172c-0.237,0-0.415,0.057-0.533,0.172 c-0.119,0.115-0.198,0.267-0.237,0.457c-0.04,0.189-0.06,0.395-0.06,0.617v4.541c0,0.221,0.018,0.429,0.053,0.622 c0.036,0.194,0.113,0.348,0.231,0.463C200.772,264.596,200.954,264.654,201.199,264.654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E8E8"
    },
    d: "M205.348,265.934v-9.604h2.49c0.648,0,1.203,0.073,1.666,0.219 c0.462,0.147,0.818,0.405,1.067,0.777c0.249,0.372,0.373,0.885,0.373,1.542c0,0.395-0.033,0.745-0.101,1.049 c-0.067,0.304-0.186,0.569-0.356,0.794s-0.409,0.405-0.717,0.54l1.328,4.684h-2.004l-1.103-4.351h-0.687v4.351H205.348z  M207.305,260.421h0.569c0.316,0,0.565-0.051,0.747-0.154c0.182-0.103,0.311-0.259,0.386-0.468 c0.075-0.21,0.113-0.468,0.113-0.777c0-0.443-0.081-0.781-0.243-1.014c-0.162-0.233-0.464-0.349-0.907-0.349h-0.664V260.421z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8E8E8"
    },
    d: "M212.226,265.934v-9.604h2.348c0.814,0,1.448,0.105,1.903,0.314 c0.454,0.21,0.777,0.538,0.966,0.984c0.19,0.447,0.285,1.017,0.285,1.713v3.498c0,0.711-0.095,1.297-0.285,1.755 c-0.19,0.458-0.508,0.796-0.954,1.013c-0.447,0.217-1.069,0.326-1.867,0.326H212.226z M214.182,264.57h0.415 c0.364,0,0.623-0.057,0.777-0.172c0.154-0.115,0.251-0.285,0.29-0.51c0.04-0.225,0.06-0.504,0.06-0.836v-3.96 c0-0.332-0.026-0.599-0.077-0.8c-0.051-0.202-0.154-0.35-0.308-0.445c-0.154-0.095-0.405-0.142-0.753-0.142h-0.403V264.57z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M132.12,190.593c-0.614,0-1.09-0.129-1.428-0.385c-0.339-0.257-0.574-0.603-0.706-1.038 c-0.132-0.435-0.198-0.92-0.198-1.454v-3.06c0-0.585,0.066-1.095,0.198-1.53c0.132-0.435,0.367-0.772,0.706-1.011 c0.338-0.239,0.814-0.358,1.428-0.358c0.542,0,0.972,0.1,1.289,0.299c0.317,0.2,0.546,0.485,0.685,0.856 c0.139,0.371,0.208,0.817,0.208,1.337v0.685h-1.145v-0.61c0-0.32-0.016-0.604-0.048-0.85c-0.032-0.246-0.12-0.437-0.262-0.572 c-0.143-0.135-0.382-0.204-0.717-0.204c-0.342,0-0.592,0.074-0.749,0.22c-0.157,0.146-0.258,0.353-0.304,0.62 c-0.047,0.268-0.07,0.579-0.07,0.936v3.434c0,0.435,0.036,0.779,0.107,1.033c0.071,0.253,0.189,0.433,0.353,0.54 c0.164,0.107,0.385,0.161,0.663,0.161c0.328,0,0.563-0.073,0.706-0.22c0.143-0.146,0.232-0.347,0.268-0.604 c0.036-0.256,0.053-0.556,0.053-0.899v-0.642h1.145v0.642c0,0.528-0.064,0.993-0.192,1.396c-0.128,0.403-0.35,0.717-0.663,0.942 C133.132,190.48,132.69,190.593,132.12,190.593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M137.672,190.593c-0.585,0-1.052-0.114-1.402-0.342c-0.349-0.229-0.599-0.555-0.749-0.979 c-0.15-0.424-0.225-0.922-0.225-1.492v-3.285c0-0.57,0.076-1.06,0.23-1.471c0.153-0.41,0.402-0.724,0.749-0.942 c0.346-0.217,0.811-0.326,1.396-0.326c0.585,0,1.049,0.11,1.391,0.332c0.342,0.221,0.59,0.535,0.744,0.941 c0.153,0.407,0.23,0.895,0.23,1.466v3.295c0,0.564-0.076,1.055-0.23,1.476c-0.153,0.421-0.401,0.747-0.744,0.979 C138.721,190.477,138.257,190.593,137.672,190.593z M137.672,189.641c0.321,0,0.564-0.066,0.728-0.198 c0.164-0.132,0.275-0.317,0.332-0.556c0.057-0.239,0.086-0.519,0.086-0.84v-3.798c0-0.321-0.029-0.597-0.086-0.829 c-0.057-0.232-0.168-0.41-0.332-0.535c-0.164-0.124-0.406-0.187-0.728-0.187c-0.32,0-0.565,0.063-0.732,0.187 c-0.168,0.125-0.28,0.303-0.337,0.535c-0.057,0.232-0.085,0.508-0.085,0.829v3.798c0,0.321,0.029,0.601,0.085,0.84 c0.057,0.239,0.169,0.424,0.337,0.556C137.107,189.575,137.351,189.641,137.672,189.641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M141.224,190.497v-8.666h0.824l2.46,5.756v-5.756h1.006v8.666h-0.77l-2.493-5.916v5.916H141.224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M146.872,190.497v-8.666h3.348v0.866h-2.14v2.889h1.659v0.856h-1.659v4.055H146.872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M151.12,190.497v-8.666h1.187v8.666H151.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M153.708,190.497v-8.666h1.744c0.578,0,1.055,0.077,1.433,0.23 c0.378,0.153,0.658,0.399,0.84,0.738c0.182,0.338,0.273,0.783,0.273,1.332c0,0.335-0.036,0.64-0.107,0.915 c-0.071,0.274-0.186,0.506-0.342,0.695c-0.157,0.189-0.363,0.326-0.62,0.412l1.23,4.343h-1.166l-1.134-4.065h-0.942v4.065 H153.708z M154.917,185.564h0.46c0.342,0,0.62-0.042,0.834-0.128c0.214-0.085,0.371-0.232,0.471-0.439 c0.1-0.207,0.149-0.496,0.149-0.866c0-0.506-0.092-0.872-0.278-1.097c-0.186-0.225-0.553-0.337-1.102-0.337h-0.535V185.564z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M159.24,190.497l0.16-8.666h1.188l1.53,7.029l1.54-7.029h1.177l0.161,8.666h-0.973l-0.096-6.291 l-1.466,6.291h-0.685l-1.455-6.291l-0.096,6.291H159.24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M168.771,190.497v-8.666h2.15c0.521,0,0.936,0.095,1.247,0.284 c0.31,0.189,0.536,0.462,0.679,0.818c0.143,0.356,0.214,0.788,0.214,1.294c0,0.456-0.08,0.852-0.241,1.188 c-0.16,0.335-0.398,0.594-0.711,0.775c-0.314,0.182-0.706,0.273-1.177,0.273h-0.952v4.033H168.771z M169.98,185.597h0.556 c0.35,0,0.624-0.039,0.824-0.118s0.342-0.216,0.428-0.412c0.085-0.196,0.128-0.472,0.128-0.829c0-0.414-0.031-0.731-0.091-0.952 c-0.061-0.221-0.187-0.375-0.38-0.46c-0.193-0.086-0.492-0.129-0.899-0.129h-0.568V185.597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M173.03,190.497l1.84-8.666h1.166l1.851,8.666h-1.144l-0.396-2.183h-1.766l-0.417,2.183H173.03z  M174.741,187.448h1.444l-0.727-3.905L174.741,187.448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M180.807,190.593c-0.499,0-0.914-0.107-1.246-0.321c-0.332-0.214-0.583-0.51-0.754-0.888 c-0.171-0.378-0.271-0.817-0.3-1.316l1.07-0.289c0.022,0.307,0.07,0.603,0.144,0.887c0.075,0.285,0.199,0.519,0.37,0.701 c0.171,0.182,0.41,0.273,0.716,0.273c0.314,0,0.551-0.088,0.711-0.262c0.161-0.175,0.241-0.427,0.241-0.754 c0-0.393-0.089-0.708-0.268-0.947c-0.178-0.239-0.402-0.479-0.674-0.722l-1.454-1.284c-0.285-0.249-0.496-0.522-0.632-0.818 c-0.135-0.296-0.203-0.661-0.203-1.097c0-0.634,0.182-1.127,0.545-1.476c0.364-0.35,0.86-0.524,1.487-0.524 c0.342,0,0.643,0.045,0.904,0.134c0.26,0.089,0.478,0.226,0.653,0.411c0.174,0.186,0.314,0.419,0.418,0.701 c0.103,0.282,0.173,0.611,0.208,0.99l-1.027,0.278c-0.021-0.285-0.064-0.547-0.128-0.786c-0.064-0.239-0.176-0.432-0.337-0.577 c-0.161-0.146-0.391-0.22-0.69-0.22c-0.299,0-0.533,0.08-0.701,0.241c-0.168,0.161-0.251,0.397-0.251,0.711 c0,0.264,0.045,0.482,0.134,0.653c0.089,0.171,0.234,0.346,0.433,0.524l1.466,1.284c0.328,0.285,0.617,0.626,0.867,1.022 c0.249,0.396,0.374,0.865,0.374,1.407c0,0.428-0.089,0.797-0.268,1.107c-0.178,0.311-0.423,0.548-0.733,0.711 C181.572,190.511,181.214,190.593,180.807,190.593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M185.867,190.593c-0.499,0-0.914-0.107-1.246-0.321c-0.332-0.214-0.583-0.51-0.754-0.888 c-0.171-0.378-0.271-0.817-0.3-1.316l1.07-0.289c0.022,0.307,0.07,0.603,0.144,0.887c0.075,0.285,0.199,0.519,0.37,0.701 c0.171,0.182,0.41,0.273,0.716,0.273c0.314,0,0.551-0.088,0.711-0.262c0.161-0.175,0.241-0.427,0.241-0.754 c0-0.393-0.089-0.708-0.268-0.947c-0.178-0.239-0.402-0.479-0.674-0.722l-1.454-1.284c-0.285-0.249-0.496-0.522-0.632-0.818 c-0.135-0.296-0.203-0.661-0.203-1.097c0-0.634,0.182-1.127,0.545-1.476c0.364-0.35,0.86-0.524,1.487-0.524 c0.342,0,0.643,0.045,0.904,0.134c0.26,0.089,0.478,0.226,0.653,0.411c0.174,0.186,0.314,0.419,0.417,0.701 c0.103,0.282,0.173,0.611,0.208,0.99l-1.027,0.278c-0.021-0.285-0.064-0.547-0.128-0.786c-0.064-0.239-0.176-0.432-0.337-0.577 c-0.16-0.146-0.391-0.22-0.69-0.22c-0.299,0-0.533,0.08-0.701,0.241c-0.168,0.161-0.251,0.397-0.251,0.711 c0,0.264,0.045,0.482,0.134,0.653c0.089,0.171,0.234,0.346,0.433,0.524l1.466,1.284c0.328,0.285,0.617,0.626,0.867,1.022 c0.249,0.396,0.374,0.865,0.374,1.407c0,0.428-0.089,0.797-0.268,1.107c-0.178,0.311-0.423,0.548-0.732,0.711 C186.632,190.511,186.274,190.593,185.867,190.593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M190.007,190.497l-1.412-8.666h1.006l0.93,6.227l1.166-6.194h0.856l1.177,6.226l0.909-6.258h0.984 l-1.391,8.666h-0.878l-1.209-6.419l-1.22,6.419H190.007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M198.811,190.593c-0.585,0-1.052-0.114-1.402-0.342c-0.35-0.229-0.599-0.555-0.749-0.979 c-0.15-0.424-0.225-0.922-0.225-1.492v-3.285c0-0.57,0.076-1.06,0.23-1.471c0.153-0.41,0.402-0.724,0.749-0.942 c0.346-0.217,0.811-0.326,1.396-0.326c0.585,0,1.049,0.11,1.391,0.332c0.342,0.221,0.59,0.535,0.744,0.941 c0.153,0.407,0.23,0.895,0.23,1.466v3.295c0,0.564-0.076,1.055-0.23,1.476c-0.153,0.421-0.401,0.747-0.744,0.979 C199.86,190.477,199.396,190.593,198.811,190.593z M198.811,189.641c0.321,0,0.564-0.066,0.727-0.198 c0.164-0.132,0.275-0.317,0.332-0.556c0.057-0.239,0.086-0.519,0.086-0.84v-3.798c0-0.321-0.029-0.597-0.086-0.829 c-0.057-0.232-0.168-0.41-0.332-0.535c-0.164-0.124-0.406-0.187-0.727-0.187c-0.321,0-0.565,0.063-0.733,0.187 c-0.168,0.125-0.28,0.303-0.337,0.535c-0.057,0.232-0.085,0.508-0.085,0.829v3.798c0,0.321,0.028,0.601,0.085,0.84 c0.057,0.239,0.169,0.424,0.337,0.556C198.246,189.575,198.491,189.641,198.811,189.641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M202.364,190.497v-8.666h1.744c0.577,0,1.055,0.077,1.433,0.23 c0.378,0.153,0.658,0.399,0.84,0.738c0.182,0.338,0.273,0.783,0.273,1.332c0,0.335-0.036,0.64-0.107,0.915 c-0.071,0.274-0.186,0.506-0.342,0.695c-0.157,0.189-0.364,0.326-0.62,0.412l1.23,4.343h-1.166l-1.134-4.065h-0.942v4.065 H202.364z M203.572,185.564h0.46c0.342,0,0.62-0.042,0.834-0.128c0.214-0.085,0.371-0.232,0.471-0.439 c0.1-0.207,0.149-0.496,0.149-0.866c0-0.506-0.092-0.872-0.278-1.097c-0.186-0.225-0.553-0.337-1.102-0.337h-0.535V185.564z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M207.916,190.497v-8.666h1.883c0.642,0,1.15,0.098,1.525,0.294 c0.375,0.196,0.642,0.49,0.802,0.882c0.161,0.393,0.241,0.881,0.241,1.466v3.188c0,0.613-0.08,1.13-0.241,1.551 c-0.161,0.421-0.421,0.74-0.781,0.958c-0.36,0.217-0.844,0.326-1.45,0.326H207.916z M209.124,189.63h0.685 c0.442,0,0.756-0.086,0.941-0.257c0.186-0.171,0.298-0.421,0.337-0.749c0.039-0.328,0.059-0.724,0.059-1.188v-2.814 c0-0.449-0.028-0.813-0.085-1.091c-0.057-0.278-0.182-0.481-0.375-0.61c-0.192-0.128-0.496-0.192-0.909-0.192h-0.653V189.63z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Characters"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M93.136,366.345l-7.744,40.339l-12.396,36.882l-3.062,5.763c0,0-3.422,5.042-3.782,8.824c-0.36,3.782,3.242,5.943,5.943,4.682 c2.701-1.261,4.142-6.483,4.682-8.824c0.54-2.341,1.621-6.483,1.981-7.924c0.36-1.441,1.081-2.521,1.081-2.521 s21.4-35.622,21.4-36.702s10.085-27.373,10.085-27.373l1.981,0.18l5.943,29.354l-16.568,34.396c0,0-5.222,6.123-4.862,6.843 c0.36,0.72,3.242,3.602,4.322,4.322c1.08,0.72,5.042,7.023,7.924,7.744c2.881,0.72,3.962,1.441,3.422-0.9 c-0.54-2.341-2.161-5.943-2.521-7.023c-0.36-1.081-1.074-8.612-1.074-8.612l24.845-32.808l-3.242-40.519L93.136,366.345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M104.362,454.433c-1.218-0.914-4.035-3.827-5.82-5.713c-0.504,0.756-0.821,1.35-0.724,1.545c0.36,0.72,3.241,3.602,4.322,4.322 c1.08,0.72,5.042,7.023,7.924,7.744c1.925,0.481,3.042,0.957,3.413,0.526C107.632,461.322,105.915,455.597,104.362,454.433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M75.451,458.337c-1.881,1.889-4.083,3.317-6.42,2.616c-2.749-0.825-2.091-4.963-1.357-7.606c-0.722,1.53-1.375,3.27-1.521,4.806 c-0.36,3.782,3.242,5.943,5.943,4.682C73.572,462.146,74.669,460.275,75.451,458.337z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M93.136,366.345 l-7.743,40.339l-12.396,36.882c0,0,1.107,3.954,5.99,1.783c0.373-1.053,0.854-1.783,0.854-1.783s21.4-35.622,21.4-36.702 s10.085-27.373,10.085-27.373l1.981,0.18l5.943,29.354l-16.568,34.396c0,0,2.155,3.628,7.275,2.288l24.78-32.722l-3.242-40.519 L93.136,366.345z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M123.551,310.104l-4.493,0.828l-20.575,59.833 c0,0,3.902,6.858,16.555,6.74c12.653-0.118,16.318-2.129,16.318-2.129l-0.355-36.184l5.193-23.945 C136.194,315.248,128.163,310.341,123.551,310.104z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M146.729,293.669c0,0,0,5.496-0.284,6.254 c-0.284,0.758-1.706,1.8-1.706,2.464s1.611,3.316,1.327,3.98c-0.284,0.663-3.127,1.421-3.127,1.421s-2.369,4.643-3.506,5.117 c-1.137,0.474-5.59-1.8-5.59-1.8l-2.558,7.865c0,0-1.137,2.179-5.401,1.516c-4.264-0.663-5.78-2.274-5.969-3.316 c-0.189-1.042-0.663-1.327-0.095-2.464c0.569-1.137,1.421-3.601,1.421-3.601l5.401-11.37l0.853-5.211 c0,0,1.895-3.695,8.907-4.453C143.413,289.31,146.729,293.669,146.729,293.669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M139.433,305.797 c0,0,0.19,1.706,2.369,2.274"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M144.55,299.449 c0,0-1.232-1.516-2.843-1.042"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M143.116,301.706c-0.101,0.487-0.453,0.825-0.786,0.756c-0.333-0.069-0.521-0.52-0.42-1.007 c0.101-0.487,0.453-0.825,0.786-0.756C143.029,300.769,143.217,301.219,143.116,301.706z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 133.843,311.104 131.095,308.64 133.085,313.757  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M131.948,298.217c0,0,3.885-1.327,4.927-1.99 c1.042-0.663-0.379-2.843,0.474-3.601s4.548-1.137,6.538-0.474c1.99,0.663,2.085,2.179,3.98,1.895 c1.895-0.284,4.264-1.8,3.222-4.453s-4.169-4.927-6.727-5.211c-2.558-0.284-5.211,0.379-8.528,0 c-3.316-0.379-6.728-1.611-8.528,1.99c-1.8,3.601-3.316,7.486-2.653,9.381c0.663,1.895,0.948,4.264,1.706,4.643 C127.115,300.776,131.948,298.217,131.948,298.217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M132.421,299.544c0,0-0.379-4.548-2.369-3.695 c-1.99,0.853-1.8,5.211-0.568,6.064c1.232,0.853,2.274-0.474,2.274-0.474"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B2B2",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M118.493,319.347l-18.951,61.495c0,0-4.927-3.885-7.675-6.538 c-2.748-2.653-3.411-3.411-3.411-3.411l6.822-15.066l1.232-4.832L76.517,364.26l-3.411-6.728l16.961-15.16 c0,0,10.423-28.9,11.086-29.279c0.663-0.379,19.614-2.937,19.614-2.937L118.493,319.347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M122.567,308.545c0,0-2.843-0.758-4.264,0.663 s-6.633,8.907-5.306,9.665c1.327,0.758,4.927-1.232,4.927-1.232l0.568,1.706L122.567,308.545z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 102.669,
    y1: 322.664,
    x2: 96.51,
    y2: 350.995
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 112.808,330.339 103.237,329.201 102.669,332.328 112.334,334.034 112.808,332.328  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M101.854,326.169 c0,0-1.013-5.63-1.238-8.669"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M101.291,327.408 c0,0-1.689-2.815-2.815-4.616"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B2B2",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M131.284,318.968c0,0-4.661,19.586-4.548,25.553 c0.113,5.967,1.689,37.605,1.689,37.605s6.08-1.126,7.093-1.464c1.013-0.338,4.954-1.576,4.954-1.576s-6.868-22.293-6.868-23.081 c0-0.788,1.238-6.08,1.238-6.08s4.053,9.12,4.616,9.795c0.563,0.676,16.071,7.667,16.071,7.667l1.38-8.23l-9.795-9.007 c0,0-2.139-17.001-2.139-18.352s0.563-9.908,0.563-9.908l-12.272-9.683L131.284,318.968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M168.818,364.617c0,0-4.912,1.071-6.172,1.197 c-1.26,0.126-3.653-0.126-4.723-0.504c-1.071-0.378-3.149-1.197-3.149-1.197s-0.441-1.259-0.126-1.952 c0.315-0.693,2.015-0.63,2.015-0.63l10.643,1.071L168.818,364.617z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 140.36,
    y1: 329.885,
    x2: 134.843,
    y2: 349.926
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 137.32,335.177 130.677,333.488 130.339,336.19 136.194,337.766  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 138.22,
    y1: 338.442,
    x2: 141.598,
    y2: 333.6
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M130.79,322.116l1.238-1.238c0,0,2.815,3.265,3.378,2.252 c0.563-1.013,1.689-3.603,0.788-7.881c-0.901-4.278-2.351-4.145-2.351-4.145l-2.558,7.865L130.79,322.116z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M193.937,367.537l-5.914,39.981l-13.569,38.931 c0,0-4.685,5.008-5.977,10.662c-1.292,5.654,2.423,5.977,4.362,4.523c1.938-1.454,6.623-13.892,6.785-14.539 c0.162-0.646,20.354-35.054,20.677-35.539c0.323-0.485,10.016-28.754,10.016-28.754l7.108,27.785l14.7,40.385 c0,0,0.969,6.946,3.392,9.692c2.423,2.746,5.977,4.685,6.623,2.262s0.161-6.623-1.615-8.562 c-1.777-1.939-4.523-5.977-4.523-5.977l-5.169-41.677l-3.202-38.982L193.937,367.537z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M230.831,406.711l-3.202-38.982l-33.692-0.191l-5.914,39.981 l-10.722,30.761l6.228,1.93c5.928-10.238,16.537-28.302,16.77-28.652c0.323-0.485,10.016-28.754,10.016-28.754l7.108,27.785 l11.655,32.019l5.956-2.007L230.831,406.711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M172.838,461.634c1.006-0.755,2.752-4.469,4.221-7.958 l-3.414,3.919l-4.038-1.131l0.7-4.085c-0.767,1.447-1.449,3.058-1.831,4.731C167.184,462.765,170.899,463.088,172.838,461.634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M242.138,462.927c0.646-2.423,0.161-6.623-1.615-8.562 c-0.122-0.134-0.25-0.279-0.38-0.43l0.865,5.438l-3.231,1.131l-5.131-6.796c0.517,2.255,1.44,5.337,2.87,6.957 C237.938,463.411,241.492,465.35,242.138,462.927z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M193.937,367.537c0,0,6.942,12.27,16.577,12.823 c9.635,0.554,17.115-12.632,17.115-12.632l-33.062-1.322L193.937,367.537z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2B2B2",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M204.848,321.02c0,0-10.816,5.264-10.912,5.934 c-0.096,0.67-7.356,29.639-7.356,29.639s-2.59,5.787,0.664,7.606s9.085-4.223,9.085-4.223l-2.393,7.562 c0,0,7.698,3.865,18.174,4.402c8.052,0.413,15.517-4.211,15.517-4.211l-1.149-7.944c0,0,6.721,4.524,9.114,3.471 c2.393-1.053,4.191-3.184,4.191-4.619s-1.149-1.819-3.063-3.924c-1.914-2.106-5.073-12.539-5.073-12.539 s-2.68-14.357-3.35-15.506c-0.67-1.149-8.997-4.882-8.997-4.882L204.848,321.02z"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "198.11,332.629 199.993,338.388 196.33,359.976  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "226.462,333.625 225.132,338.166 226.48,359.784  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M194.788,364.635c0,0,16.28,4.984,32.449,0.443"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M74.315,349.482c0,0-2.961,0.634-3.595,0.952 c-0.634,0.317-0.74,1.586-1.586,2.115c-0.846,0.529-2.115,1.269-1.375,1.798c0.74,0.529,2.285,0.922,3.046-0.121 c0.761-1.042,2.67-1.925,2.985-1.801"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M181.774,364.014c0,0-1.126-0.066-1.789-0.596 c-0.663-0.53-1.723-0.729-2.319-0.861c-0.596-0.133-0.398-0.663,0.464-0.994s2.452-0.199,3.247,0.133s1.193,0.729,1.193,0.729 L181.774,364.014z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.735,
    y: 353.732,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    width: 182.298,
    height: 8.42
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M109.896,320.106c-20.896,0-37.836,16.94-37.836,37.836 c0,20.896,16.94,37.836,37.836,37.836c20.896,0,37.836-16.94,37.836-37.836C147.732,337.046,130.793,320.106,109.896,320.106z  M109.896,385.878c-15.428,0-27.936-12.507-27.936-27.936s12.507-27.936,27.936-27.936c15.428,0,27.936,12.507,27.936,27.936 S125.325,385.878,109.896,385.878z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M292.257,353.732v39.488h7.766 c-0.002-0.073-0.011-0.144-0.011-0.218c0-5.064,4.105-9.169,9.169-9.169c5.064,0,9.169,4.105,9.169,9.169 c0,0.073-0.009,0.145-0.011,0.218h6.695v-39.488H292.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M249.647,353.732v22.663h4.457 c-0.001-0.042-0.006-0.083-0.006-0.125c0-2.906,2.356-5.263,5.262-5.263c2.906,0,5.262,2.356,5.262,5.263 c0,0.042-0.005,0.083-0.006,0.125h3.842v-22.663H249.647z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M218.068,291.215c0,0,2.628-2.151,1.434-4.301 c-1.195-2.151-6.452-5.337-8.602-4.54c-2.151,0.797-6.372,5.257-6.691,6.93c-0.319,1.673,3.027,3.983,3.664,4.062 C208.51,293.445,213.927,290.259,218.068,291.215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M212.891,290.498c0,0-8.602,2.389-10.992,7.009 c-2.389,4.62-2.549,5.655-1.195,7.885c1.354,2.23,4.699,6.213,7.806,7.806c3.106,1.593,12.983-0.717,12.983-0.717 s3.027-1.354,3.982-3.744c0.956-2.389,3.106-5.735,1.673-9.319c-1.434-3.584-7.806-8.522-9.797-9.08 C215.36,289.781,212.891,290.498,212.891,290.498z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M219.152,296.542c0,0-4.29,2.64-6.49,4.18 c-2.2,1.54-4.84,2.42-4.84,2.42s-1.98,0.88-1.54,3.19c0.44,2.31,1.273,10.291,1.273,10.291l-1.493,3.24l6.38,7.04l5.06-6.6 l0.55-3.41c0,0,4.62-2.86,4.73-3.52s1.43-10.34,1.32-11.331C223.992,301.052,219.152,296.542,219.152,296.542z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M219.9,303.322 c0,0-0.239,2.151-0.239,2.469s1.912,1.991,1.195,2.628c-0.717,0.637-2.151,1.036-2.151,1.036"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M218.945,311.446 c0,0-0.796,0.876-2.549-0.956"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M218.052,316.893c0,0-1.816-0.19-2.532-0.668c-0.717-0.478-2.788-2.071-2.788-2.071l4.062,7.009l0.708-0.86L218.052,316.893z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M208.67,305.233c0,0-1.513-4.54-3.266-1.991 c-1.752,2.549,1.036,6.133,2.39,6.053"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#263238"
    },
    cx: 215.958,
    cy: 304.994,
    rx: 0.677,
    ry: 0.956
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#263238"
    },
    cx: 221.932,
    cy: 304.994,
    rx: 0.677,
    ry: 0.956
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M214.166,302.923 c0,0,1.434-1.434,3.345-0.319"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M220.617,302.445 c0,0,2.151-0.876,2.628,0.797"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "206.041,317.42 211.617,324.509 207.794,328.65  203.492,320.924  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "211.617,324.509 212.442,326.903 210.502,325.942  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "213.608,323.314 216.316,328.65 220.458,321.641  217.67,319.411  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "213.608,323.314 212.442,326.903 214.404,324.987  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M182.055,360.025c0,0-1.128,3.215-0.812,3.657 c0.331,0.464,1.415,1.016,1.716-0.039s0.603-3.406,0.206-4.069C182.768,358.912,182.055,360.025,182.055,360.025z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M183.844,361.019c0,0-1.128,3.215-0.812,3.657 c0.331,0.464,1.415,1.016,1.716-0.039c0.301-1.055,0.603-3.407,0.205-4.069C184.557,359.906,183.844,361.019,183.844,361.019z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M186.163,360.887c0,0-1.127,3.215-0.812,3.657 c0.331,0.464,1.415,1.016,1.716-0.039c0.301-1.055,0.603-3.407,0.206-4.069C186.876,359.773,186.163,360.887,186.163,360.887z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M188.008,361.461c0,0-0.856,2.727-0.616,3.103 c0.251,0.393,1.074,0.862,1.303-0.033c0.229-0.895,0.458-2.89,0.156-3.452C188.549,360.516,188.008,361.461,188.008,361.461z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M72.947,355.133c0,0-3.387-0.646-3.692-0.13 c-0.319,0.541-0.462,2.07,0.626,2.194c1.088,0.124,3.386-0.076,3.868-0.752C74.231,355.77,72.947,355.133,72.947,355.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M72.634,357.678c0,0-3.387-0.646-3.692-0.129 c-0.319,0.541-0.463,2.07,0.626,2.194c1.088,0.124,3.386-0.076,3.868-0.752C73.918,358.315,72.634,357.678,72.634,357.678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M73.554,360.624c0,0-3.387-0.646-3.692-0.129 c-0.319,0.541-0.462,2.07,0.626,2.194c1.088,0.124,3.386-0.076,3.868-0.752C74.838,361.261,73.554,360.624,73.554,360.624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M73.652,363.137c0,0-2.839-0.419-3.107-0.017 c-0.281,0.421-0.436,1.595,0.478,1.665c0.914,0.07,2.854-0.133,3.275-0.661C74.72,363.596,73.652,363.137,73.652,363.137z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M240.826,360.025c0,0,1.128,3.215,0.812,3.657 c-0.331,0.464-1.415,1.016-1.716-0.039c-0.302-1.055-0.603-3.406-0.205-4.069C240.113,358.912,240.826,360.025,240.826,360.025z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M239.037,361.019c0,0,1.128,3.215,0.812,3.657 c-0.331,0.464-1.415,1.016-1.716-0.039c-0.301-1.055-0.603-3.407-0.205-4.069C238.324,359.906,239.037,361.019,239.037,361.019z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M236.718,360.887c0,0,1.127,3.215,0.812,3.657 c-0.331,0.464-1.415,1.016-1.716-0.039c-0.301-1.055-0.603-3.407-0.206-4.069C236.005,359.773,236.718,360.887,236.718,360.887z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M234.873,361.461c0,0,0.856,2.727,0.616,3.103 c-0.252,0.393-1.074,0.862-1.303-0.033c-0.229-0.895-0.458-2.89-0.156-3.452C234.332,360.516,234.873,361.461,234.873,361.461z"
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 155.53,
    y1: 367.388,
    x2: 154.396,
    y2: 362.224
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M163.513,365.413l6.44-0.92l3.011-2.592 c0,0,1.087-3.429,1.254-3.847c0.167-0.418-0.167-1.254-1.004-1.004c-0.836,0.251-1.087,1.505-1.087,1.505 s-0.669-2.342-1.338-1.84c-0.669,0.502-0.753,1.171-0.753,1.171s-1.087-1.338-1.589-0.92c-0.502,0.418-0.669,1.673-0.669,1.673 s-1.255-1.004-1.673-0.418c-0.418,0.585,0,1.589,0,1.589l0.502,2.007l-0.836,0.167l-3.512,0.167"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M170.036,357.886c0,0,0.696,2.584,0.793,2.874 c0.097,0.291-0.542,3.397-0.876,3.733"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M172.127,358.555c0,0,0.785,2.496,0.397,3.513"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M167.778,358.638l1.113,2.218c0,0-0.048,2.809-0.436,3.536"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 166.607,
    y1: 361.816,
    x2: 166.663,
    y2: 362.891
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M162.594,362.31c0,0-0.969,0.872-0.145,2.034"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg206028186325245);
export default __webpack_public_path__ + "static/media/20602818_6325245.ee56b6d80b960945cb806503ddbc0bfe.svg";
export { ForwardRef as ReactComponent };